import { AnyAction } from 'redux';
import { CheckoutActions } from '../checkout.actions';

export const sammelantragsnummerReducer = function (
  sectionState: string = null,
  action: AnyAction,
): string {
  switch (action.type) {
    case CheckoutActions.SAMMELANTRAGSNUMMER_GENERATED: {
      return action.payload + '';
    }
    default:
      return sectionState;
  }
};
